module.exports = function() {
  return new Worker(__webpack_public_path__ + "2a2f0aa90d54deff2893.worker.js");
};